module.exports = __webpack_public_path__ + "img/loading.7af8e46c.gif";